import React, { useEffect, useState } from "react";
import { blacklistAPI } from "../../Api";
import {
  Container, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination, TextField, MenuItem, Select, FormControl, InputLabel, Button
} from "@mui/material";

const BlacklistList = () => {
  const [blacklist, setBlacklist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState({
    last_name: '',
    first_name: '',
    merchant: ''
  });
  const [merchants, setMerchants] = useState([]);

  const fetchBlacklist = async () => {
    setLoading(true);
    try {
      const res = await blacklistAPI.getAll({
        page,
        limit: rowsPerPage,
        filters
      });
      
      if (res.data && res.data.success) {
        setBlacklist(res.data.data || []);
        setTotalRecords(res.data.totalRecords || 0);
      } else {
        setBlacklist([]);
      }
    } catch (e) {
      console.error('Error loading blacklist:', e);
      setBlacklist([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlacklist();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    setPage(0);
    fetchBlacklist();
  };

  const handleClearFilters = () => {
    setFilters({ last_name: '', first_name: '', merchant: '' });
    setPage(0);
    setTimeout(() => fetchBlacklist(), 100);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Черный список
      </Typography>

      {/* Фильтры */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField
            label="Фамилия"
            name="last_name"
            value={filters.last_name}
            onChange={handleFilterChange}
            size="small"
            sx={{ minWidth: 200 }}
          />
          <TextField
            label="Имя"
            name="first_name"
            value={filters.first_name}
            onChange={handleFilterChange}
            size="small"
            sx={{ minWidth: 200 }}
          />
          <Button variant="contained" onClick={handleSearch}>
            Поиск
          </Button>
          <Button variant="outlined" onClick={handleClearFilters}>
            Сбросить
          </Button>
        </Box>
      </Paper>

      {/* Таблица */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Фамилия</strong></TableCell>
              <TableCell><strong>Имя</strong></TableCell>
              <TableCell><strong>Отчество</strong></TableCell>
              <TableCell><strong>Дата рождения</strong></TableCell>
              <TableCell><strong>Комментарий</strong></TableCell>
              <TableCell><strong>Мерчант</strong></TableCell>
              <TableCell><strong>Дата добавления</strong></TableCell>
              <TableCell><strong>Дата обновления</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Загрузка...</TableCell>
              </TableRow>
            ) : blacklist.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Нет записей</TableCell>
              </TableRow>
            ) : (
              blacklist.map((item) => (
                <TableRow key={item._id}>
                  <TableCell>{item.last_name}</TableCell>
                  <TableCell>{item.first_name || '-'}</TableCell>
                  <TableCell>{item.middle_name || '-'}</TableCell>
                  <TableCell>
                    {item.birth_date ? new Date(item.birth_date).toLocaleDateString('ru-RU') : '-'}
                  </TableCell>
                  <TableCell>{item.comment || '-'}</TableCell>
                  <TableCell>{item.merchant_id?.name || '-'}</TableCell>
                  <TableCell>{formatDate(item.created_at)}</TableCell>
                  <TableCell>{formatDate(item.updated_at)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[25, 50, 100]}
          labelRowsPerPage="Записей на странице:"
        />
      </TableContainer>
    </Container>
  );
};

export default BlacklistList;
